// useNotification.ts
import { toast } from "sonner"

const useNotification = () => {
  const notifySuccess = (message: string) => {
    toast.success(message, {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="12" fill="#21C16B" />
          <g clipPath="url(#clip0_2908_563)">
            <path d="M7.33325 12L10.6666 15.3333L17.3333 8.66663" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </g>
          <defs>
            <clipPath id="clip0_2908_563">
              <rect width="16" height="16" fill="white" transform="translate(4 4)" />
            </clipPath>
          </defs>
        </svg>
      ),
      style: {
        border: "1px solid #21C16B",
        backgroundColor: "#F0FDF5",
        color: "#21C16B",
        borderRadius: "16px",
      },
      /* duration: Infinity, */
    })
  }

  const notifyError = (message: string) => {
    toast.error(message, {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <rect width="24" height="24" rx="12" fill="#FB3748" />
          <path d="M16 8L8.00054 15.9995M15.9995 16L8 8.00057" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ),
      style: {
        border: "1px solid #FB3748",
        backgroundColor: "#FFF1F2",
        color: "#FB3748",
        borderRadius: "16px",
      },
    })
  }

  const notifyInfo = (message: string) => {
    toast.info(message, {
      icon: (
        <svg
          fill="#2196F3"
          height="24"
          viewBox="0 0 24 24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm1 17h-2v-6h2Zm0-8h-2V7h2Z" />
        </svg>
      ),
      style: {
        border: "1px solid #2196F3",
      },
      /* duration: Infinity, */
    })
  }

  const notifyWarning = (message: string) => {
    toast.warning(message, {
      icon: (
        <svg
          fill="#FF9800"
          height="24"
          viewBox="0 0 24 24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0Zm1 17h-2v-2h2Zm0-4h-2V7h2Z" />
        </svg>
      ),
      style: {
        border: "1px solid #FF9800",
      },
      /* duration: Infinity, */
    })
  }

  return {
    notifyError,
    notifyInfo,
    notifySuccess,
    notifyWarning,
  }
}

export default useNotification
